import { useState, useEffect } from 'react';
import _ from 'lodash';

export function useWindowDimension() {
    const [dimension, setDimension] = useState([window.innerWidth, window.innerHeight]);
    useEffect(() => {
        const debouncedResizeHandler = _.debounce(() => {
            setDimension([window.innerWidth, window.innerHeight]);
        }, 100);
        window.addEventListener('resize', debouncedResizeHandler);
        return () => window.removeEventListener('resize', debouncedResizeHandler);
    }, []);
    return dimension;
}
